export const register = {
  // Hero
  heroLabel: 'Join the Directory',
  heroTitle: 'Register Your Talent',
  heroDescription: 'Be part of the most complete live music directory in Las Vegas. Reach thousands of event organizers looking for artists like you.',

  // Benefits
  benefitsLabel: 'Why Register?',
  benefitsTitle: 'What You Get',
  benefit1Title: 'Visibility',
  benefit1Description: 'Your profile appears before thousands of event organizers searching for live music in Las Vegas.',
  benefit2Title: 'Verified Reviews',
  benefit2Description: 'Build your reputation with verified reviews from real clients who have hired you.',
  benefit3Title: 'Direct Contact',
  benefit3Description: 'Clients contact you directly through the platform. No intermediaries, no commissions.',
  benefit4Title: 'Growth',
  benefit4Description: 'Access more events and expand your professional network in the entertainment capital.',

  // Form
  formLabel: 'Registration Form',
  formTitle: 'Complete Your Registration',
  formDescription: 'Fill in the following information to create your artist profile. We will review it and contact you within 48 hours.',
  fieldName: 'Artist or Band Name',
  fieldNamePlaceholder: 'e.g. The Jazz Quartet, Maria Acoustic',
  fieldEmail: 'Email',
  fieldEmailPlaceholder: 'your@email.com',
  fieldPhone: 'Phone Number',
  fieldPhonePlaceholder: '+1 (702) 555-0000',
  fieldCategory: 'Category',
  categorySoloist: 'Soloist',
  categoryDuo: 'Duo',
  categoryTrio: 'Trio',
  categoryQuartet: 'Quartet',
  categoryFullBand: 'Full Band',
  categoryDJ: 'DJ',
  categoryOther: 'Other',
  fieldGenre: 'Musical Genre',
  genreJazz: 'Jazz',
  genrePop: 'Pop',
  genreRock: 'Rock',
  genreClassical: 'Classical',
  genreLatin: 'Latin',
  genreCountry: 'Country',
  genreElectronic: 'Electronic',
  genreRnb: 'R&B / Soul',
  genreOther: 'Other',
  fieldBio: 'Short Description',
  fieldBioPlaceholder: 'Tell us about your style, experience, and what makes you special...',
  fieldWebsite: 'Website or Social Media (optional)',
  fieldWebsitePlaceholder: 'https://...',
  fieldVideo: 'Video Link (optional)',
  fieldVideoPlaceholder: 'YouTube or Vimeo link...',
  submitButton: 'Send Registration',
  submitting: 'Sending...',
  successTitle: 'Registration Sent!',
  successMessage: 'Thank you for registering. We will review your profile and contact you within 48 hours.',
  backToHome: 'Back to Home',
  requiredField: 'This field is required',
  invalidEmail: 'Please enter a valid email',

  // CTA
  ctaTitle: 'Already Part of the Community?',
  ctaDescription: 'If you have questions about your registration or need help, contact us directly.',
  ctaButton: 'Contact Us',
};

export default register;